import type React from 'react';

import { Input } from 'ui/input';

import {
  formatEligibilityValue,
  sanitizeEligibilityValue,
} from '../helpers/format-eligibility-value';

export interface EligibilityValueFieldProps {
  label: string;
  labelFor: string;
  value: string;
  onChange: (value: string) => void;
  isCurrency: boolean;
  /** Whole numbers only (no decimals), shown as an end adornment (e.g. "miles" for Distance). */
  unitSuffix?: string;
  errorMessage?: string;
  'data-testid'?: string;
}

const EligibilityValueField = ({
  label,
  labelFor,
  value,
  onChange,
  isCurrency,
  unitSuffix,
  errorMessage,
  'data-testid': dataTestId = labelFor,
}: EligibilityValueFieldProps) => {
  const isWholeNumber = isCurrency || !!unitSuffix;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void =>
    onChange(sanitizeEligibilityValue(event.target.value, isWholeNumber));

  return (
    <Input
      label={label}
      id={labelFor}
      required
      type="text"
      inputMode="decimal"
      value={formatEligibilityValue(value, isCurrency)}
      startAdornment={isCurrency ? '$' : null}
      endAdornment={unitSuffix ?? null}
      errorMessage={errorMessage}
      placeholder=""
      onChange={handleChange}
      data-testid={dataTestId}
    />
  );
};

export default EligibilityValueField;
